import { _ProductDetail } from "./Products";

import SimilarProductsItem from "./SimilarProductsItem";
interface SimilarProductsProps {
    pDetailData: _ProductDetail
    handleProductItem: (index: string) => void; // Replace 'number' with the actual type of index
    handlerClose: () => void;
    handlerSimilarProduct: (index: string) => void;
  }
  const SimilarProducts: React.FC<SimilarProductsProps> = ({ pDetailData, handleProductItem, handlerClose, handlerSimilarProduct }) => {
    return (
        <div className="similar">
            <div className="inner">
                <h2>Podobné střihy</h2>

                <div className="products">
                    {pDetailData.related ? pDetailData.related.map((Val) => {
                        return (
                            <SimilarProductsItem 
                                key={Val.id} 
                                Val={Val}
                                handleProductItem={handleProductItem}
                                handlerClose={handlerClose}
                                handlerSimilarProduct={() => handlerSimilarProduct(Val.slug)}
                            />
                        )
                    }) : null}
                </div>
            </div>
        </div>
    )
}

export default SimilarProducts;